import React, { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Upload, Trash2, FileText, Download } from "lucide-react";

export default function Files() {
  const { t } = useI18n();
  const [files, setFiles] = useState([]);
  const inputRef = useRef();

  const load = async () => { const { data } = await api.get("/files"); setFiles(data); };
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    if (inputRef.current) inputRef.current.value = "";
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Delete file?")) return;
    await api.delete(`/files/${id}`); load();
  };

  const dl = async (id, name) => {
    const res = await api.get(`/files/${id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url; a.download = name; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">Files</div>
          <h1 className="font-heading text-3xl font-bold text-slate-900 tracking-tight mt-1">Files</h1>
        </div>
        <label className="cursor-pointer inline-flex items-center gap-2 px-4 py-2 bg-[#0052CC] text-white rounded-md text-sm font-semibold">
          <Upload className="w-4 h-4" /> Upload
          <input data-testid="file-upload-input" ref={inputRef} type="file" className="hidden" onChange={upload} />
        </label>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg overflow-x-auto">
        <table className="w-full text-sm" data-testid="files-table">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50">
              {["Name", "Type", "Size", "Date", "Actions"].map((h) => (
                <th key={h} className="py-3 px-4 text-left text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {files.length === 0 ? (
              <tr><td colSpan={5} className="py-8 text-center text-slate-400">{t("common.no_data")}</td></tr>
            ) : files.map((f) => (
              <tr key={f.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="py-3 px-4 font-medium text-slate-900 flex items-center gap-2"><FileText className="w-4 h-4 text-slate-400" /> {f.original_filename}</td>
                <td className="py-3 px-4 text-slate-600">{f.content_type}</td>
                <td className="py-3 px-4 text-slate-600">{(f.size / 1024).toFixed(1)} KB</td>
                <td className="py-3 px-4 text-slate-600">{new Date(f.created_at).toLocaleDateString()}</td>
                <td className="py-3 px-4 text-right">
                  <button onClick={() => dl(f.id, f.original_filename)} className="p-1.5 text-slate-500 hover:text-[#0052CC]"><Download className="w-4 h-4" /></button>
                  <button onClick={() => del(f.id)} className="p-1.5 text-slate-500 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
